import event from '../../event/event';

export default event('/haloGpt/page/answer');
